import {OrderType} from '../../../smoothr-web-app-core/enums/OrderType';
import {getPrice, getSlotsByOrder, numberD} from '../../../smoothr-web-app-core/utils/utils';
import {AfterContentInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {IonContent, IonSlides, ModalController, PickerController} from '@ionic/angular';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import * as moment from 'moment';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import {TosPage} from '../../pages/tos/tos.page';
import {PrivacyPage} from '../../pages/privacy/privacy.page';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {Moment} from 'moment';
import {OrderUtils} from '../../../smoothr-web-app-core/utils/order-utils';
import {isVenueOpen, numberToCurrency} from '../../../smoothr-web-app-core/utils/utils';
import Order from '../../../smoothr-web-app-core/models/Order';
import {AnalyticsService} from '../../../smoothr-web-app-core/services/analytics/analytics.service';
import {TimeUtils} from '../../../smoothr-web-app-core/utils/time-utils';
import Article from '../../../smoothr-web-app-core/models/Article';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import ArticleGroup from 'src/smoothr-web-app-core/models/ArticleGroup';
import {environment} from 'src/environments/environment';
import {PhoneNumberFormat, PhoneNumberUtil} from 'google-libphonenumber';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {NavigationService, NAVIGATIONURLS} from 'src/app/services/navigation.service';
import Customer from 'src/smoothr-web-app-core/models/Customer';
import {calculateGeoDistance} from 'src/maps/utils/maps';
import {ValidationUtils} from 'src/smoothr-web-app-core/utils/validation-utils';
import {MapsUtils} from 'src/smoothr-web-app-core/utils/maps-utils';
import Table from 'src/smoothr-web-app-core/models/Table';
import {CustomerAuth} from 'src/smoothr-web-app-core/models/CustomerAuth';
import {SubscriptionTransaction} from 'src/smoothr-web-app-core/models/SubscriptionTransactions';
import {Api} from 'src/smoothr-web-app-core/api/api';
import {AlertInfoModalComponent} from '../alert-info-modal/alert-info-modal.component';
import {InfoModalSecondViewComponent} from '../info-modal-second-view/info-modal-second-view.component';
// import {SearchCountryField, CountryISO, PhoneNumberFormat} from 'ngx-intl-tel-input';
export const phoneCountries: {code: string; tel: string}[] = [
	{
		code: 'de',
		tel: '+49'
	},
	{
		code: 'au',
		tel: '+43'
	},
	{
		code: 'ua',
		tel: '+380'
	}
];
@Component({
	selector: 'app-checkout-modal',
	templateUrl: './checkout-modal.component.html',
	styleUrls: ['checkout-modal.component.scss']
})
export class CheckoutModalComponent extends RepositoryDirective implements OnInit, AfterContentInit {
	orderUtils = OrderUtils;
	loading = false;
	now: moment.Moment;
	pt = PreorderType;
	nameError: string;
	emailError: string;
	phoneError: string;
	streetNumberError: string;
	orderAtError: string;
	streetError: string;
	postalCodeError: string;
	hadPostalCode = false;
	customer: Customer;
	customerAuth: CustomerAuth = this.repository._customerAuth;
	isVenueOpen = false;
	tip: number;
	showRePassword = false;
	showPassword = false;
	preferredCountries = ['de', 'fr', 'us'];
	defaultCountry = 'de';
	ifUserAlreadySignIn = false;
	separateDialCode = true;
	numberD = numberD;
	orderForm: FormGroup;
	fullName = 'fullName';
	email = 'email';
	phone = 'phone';
	password = 'password';
	rePassword = 'rePassword';
	street = 'street';
	houseNumber = 'houseNumber';
	postcode = 'postcode';
	city = 'city';
	createAccount = 'createAccount';
	orderAt = 'orderAt';

	numberToCurrency = numberToCurrency;
	slots: Moment[] = [];
	environment = environment;
	public userSubscription = this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription);

	@ViewChild(IonContent, {static: false}) content;
	@ViewChild(IonSlides, {static: false}) slides: IonSlides;
	slideOptions = {
		spaceBetween: 0,
		initialSlide: 0,
		speed: 400,
		allowTouchMove: false
	};
	isOverviewPage = false;

	constructor(
		private modalCtrl: ModalController,
		protected repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private pickerCtrl: PickerController,
		private translate: TranslateService,
		private analytics: AnalyticsService,
		private cdr: ChangeDetectorRef,
		private fb: FormBuilder,
		private navigationService: NavigationService
	) {
		super(repository);
		if (this.address && this.address.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
		if (this.order && this.order.preorder && this.order.preorder.postalCode && this.address.postalCode.length > 0) {
			this.hadPostalCode = true;
		}
	}

	static async show(modalCtrl: ModalController, analytics: AnalyticsService, order: Order, tip: number) {
		const modal = await modalCtrl.create({
			component: CheckoutModalComponent,
			componentProps: {
				tip
			},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
		analytics.beginCheckout(order);
		return await modal.onDidDismiss();
	}

	ngOnInit() {
		super.ngOnInit();
		this.analytics.checkoutProgress(this.order, null, 1);
		this.analytics.customerBeginsCheckout();
		this.loadSlots();
		this.createOrderForm();
		this.checkCustomer();
		this.checkPrevOrder();
	}
	ngAfterContentInit(): void {}
	onOrder() {
		super.onOrder();
		this.cdr.detectChanges();
	}
	checkCustomer() {
		if (this.customer) {
			if (this.customer?.name) {
				this.orderForm.patchValue({
					fullName: this.customer?.name ?? ''
				});
			}
			if (this.customer?.email) {
				this.orderForm.patchValue({
					email: this.customer?.email ?? ''
				});
			}
			if (this.customer?.phone) {
				console.log(this.customer?.phone);
				this.orderForm.patchValue({
					phone: {
						internationalNumber: this.repository._previousPreorder?.phone ?? '+49' + this.customer?.phone ?? '',
						dialoCode: '+49',
						isoCode: 'de',
						nationalNumber: (this.repository._previousPreorder?.phone ?? this.customer?.phone).trim().replace('+49', '')
					}
				});
			}
		}
	}
	checkPrevOrder() {
		if (this.order && this.order.preorder) {
			if (this.repository._previousPreorder) {
				if (this.repository._previousPreorder?.name) {
					this.orderForm.patchValue({
						fullName: this.repository._previousPreorder?.name ?? ''
					});
				}
				if (this.repository._previousPreorder?.email) {
					this.orderForm.patchValue({
						email: this.repository._previousPreorder?.email ?? ''
					});
				}
				if (this.repository._previousPreorder?.phone) {
					this.orderForm.patchValue({
						phone: {
							internationalNumber: this.repository._previousPreorder?.phone ?? '',
							dialoCode: '+49',
							isoCode: 'de',
							nationalNumber: this.repository._previousPreorder?.phone.trim().replace('+49', '')
						}
					});
				}
			}
		}
	}

	onAddress() {
		super.onAddress();
		this.hadPostalCode =
			this.hadPostalCode || (this.address && this.address.postalCode && this.address.postalCode.length > 0);
		this.reloadAddress;
	}

	onCustomer() {
		super.onCustomer();
		if (this.customer) {
			if (this.customer.postalCode && this.customer.postalCode.length > 0) {
				this.hadPostalCode = true;
			}
			if (!this.order.preorder.email) {
				this.order.preorder.email = this.customer.email;
			}
			if (!this.order.preorder.name) {
				this.order.preorder.name = this.customer.name;
			}
			if (!this.order.preorder.companyName) {
				this.order.preorder.companyName = this.customer.companyName;
			}
			if (!this.order.preorder.phone) {
				this.order.preorder.phone = this.customer.phone;
			}
			if (!this.order.preorder.floor) {
				this.order.preorder.floor = this.customer.floor;
			}
			if (!this.order.preorder.subcard) {
				this.order.preorder.subcard = this.customer.subcard;
			}
			if (this.order.preorder.type === PreorderType.DELIVERY) {
				if (!this.order.preorder.street) {
					this.order.preorder.street = this.customer.street;
				}
				if (!this.order.preorder.postalCode) {
					this.order.preorder.postalCode = this.customer.postalCode;
				}
				if (!this.order.preorder.city) {
					this.order.preorder.city = this.customer.city;
				}
				if (!this.order.preorder.number && this.order.preorder.street === this.customer.street) {
					this.order.preorder.number = this.customer.number;
				}
			}
		}
	}

	async close() {
		await this.updateForm();

		const data = {
			preorder: this.order.preorder,
			orderAt: this.getFormControlValue('orderAt'),
			asap: this.getFormControlValue('orderAt') ? false : true
		};
		this.repository.previousPreorder.emit(this.order.preorder);
		await this.modalCtrl.dismiss(data);
	}

	async updateForm() {
		this.order.preorder.name = this.getFormControlValue('fullName');
		this.order.preorder.phone = this.getFormControlValue('phone')?.internationalNumber;
		this.order.preorder.email = this.getFormControlValue('email');
		this.order.preorder.note = this.getFormControlValue('note');
		this.order.orderAt = this.getFormControlValue('orderAt');
		if (this.order.preorder.type === PreorderType.DELIVERY) {
			this.order.preorder.city = this.getFormControlValue('city');
			this.order.preorder.postalCode = this.getFormControlValue('postcode');
			this.order.preorder.number = this.getFormControlValue('houseNumber');
			this.order.preorder.street = this.getFormControlValue('street');
		}
		this.repository.order.emit(this.order);
	}
	async dismiss() {
		await this.modalCtrl.dismiss();
	}
	reloadAddress() {
		if (
			this.order &&
			this.order.preorder &&
			this.address &&
			this.order.preorder.type === PreorderType.DELIVERY &&
			this.orderForm
		) {
			this.orderForm.patchValue({
				city: this.address?.city ?? '',
				street: this.address?.street ?? '',
				postcode: this.address?.postalCode && this.address?.postalCode?.length > 0 ? this.address.postalCode : '',
				houseNumber: this.address?.number
			});
		}
	}

	async openTos() {
		window.open(TosPage.url, '_blank');
	}

	async openPrivacy() {
		window.open(PrivacyPage.url, '_blank');
	}

	slotToText(slot: Moment): string {
		const asapPossible = (OrderUtils.isInside(this.order) || OrderUtils.isTakeAway(this.order)) && this.isVenueOpen;
		if (!slot) {
			return this.translate.instant(asapPossible ? 'checkout_modal.first_slot' : 'checkout_modal.choose_slot');
		}
		const slotMoment = moment(slot);
		const sameDay = TimeUtils.isSameDate(slotMoment, moment());
		if (sameDay) {
			return slotMoment.format('HH:mm');
		} else {
			return slotMoment.format('DD.MM. HH:mm');
		}
	}

	onVenue() {
		this.isVenueOpen = isVenueOpen(this.venue);
	}

	onVenueError(error) {
		super.onVenueError(error);
		this.isVenueOpen = false;
		if (this.order) {
			this.order.asap = false;
		}
	}

	hiddenInCart(article: Article): boolean {
		return article.tags && article.tags.find(tag => tag.identifier === 'hide_cart') !== undefined;
	}

	async onButtonClick() {
		this.orderForm.markAllAsTouched();
		if (this.isValid()) {
			return;
		}
		if (this.order?.preorder?.type === PreorderType.DELIVERY) {
			if (!(await this.submitFormCustomValidator())) {
				return;
			}
		}
		if (!this.isOverviewPage) {
			await this.toOverview();
		} else {
			if (this.customer.isAnonymous && this.getFormControlValue(this.createAccount) && !this.ifUserAlreadySignIn) {
				await this.signUp();
			}
			await this.close();
		}
	}
	async signUp() {
		try {
			await Api.signUpWithCredentials(
				{
					name: this.getFormControlValue(this.fullName),
					email: this.getFormControlValue(this.email),
					phone: this.getFormControlValue(this.phone)?.internationalNumber,
					preferredVenues: []
				},
				this.getFormControlValue('password')
			);
			await InfoModalSecondViewComponent.show(
				this.modalCtrl,
				'Konto erstellt!',
				'Dein Konto wurde erfolgreich erstellt. Viel Spaß beim Bestellen!'
			);
		} catch (e) {
			console.log(e);
		}
	}
	async submitFormCustomValidator() {
		let controlStreetValue = this.getFormControlValue('street').trim();
		let controlHouseNumberValue = this.getFormControlValue('houseNumber').trim();
		let controlPostalCodeValue = this.getFormControlValue('postcode').trim();
		let controlCityValue = this.getFormControlValue('city').trim();
		if (
			OrderUtils.isDelivery(this.order) &&
			(controlStreetValue !== this.address.street ||
				controlPostalCodeValue !== this.address.postalCode ||
				controlCityValue !== this.address.city ||
				controlHouseNumberValue !== this.address.number)
		) {
			try {
				const pred =
					controlStreetValue + ' ' + controlHouseNumberValue + ', ' + controlCityValue + ' ' + controlPostalCodeValue;
				const geocode = await MapsUtils.getPlace(pred);
				const address = MapsUtils.placeToAddress(geocode);
				const addressValidationResult = ValidationUtils.validateAddress(address, true);
				if (addressValidationResult) {
					// this.streetError = this.translate.instant(addressValidationResult);
					this.snackbarCtrl.open(this.translate.instant('errors.street_not_found'), null, {
						duration: 2000
					});
					this.orderForm.controls['street'].setErrors({street_not_found: true});

					return false;
				}
				const delivers =
					(this.venue.deliveryByRadius &&
						calculateGeoDistance(
							address.lat,
							address.lng,
							this.venue.location.coordinates[1],
							this.venue.location.coordinates[0]
						) <= this.venue.deliveryRadius) ||
					(this.venue.isPostalDelivery && this.venue.deliveryPostalCodes.indexOf(address.postalCode));
				if (!delivers) {
					console.log('errorDelivers');

					this.orderForm.controls['street'].setErrors({street_delivery: true});

					this.snackbarCtrl.open(this.translate.instant('errors.street_delivery'), null, {
						duration: 2000
					});
					return false;
				}
				this.repository.address.emit(address);
				this.orderForm.patchValue({
					street: this.address.street
				});
				return true;
			} catch (e) {
				console.log('errorDelivers');

				this.orderForm.controls['street'].setErrors({street_not_found: true});
				this.snackbarCtrl.open(this.translate.instant('errors.street_not_found'), null, {
					duration: 2000
				});
				return false;
			}
		} else {
			return true;
		}
	}
	async toOverview() {
		await this.slides.update();
		await this.slides.slideNext();
		this.isOverviewPage = true;
	}
	async editPersonalData() {
		await this.slides.slideTo(0);
		this.isOverviewPage = false;
	}
	slotSelected($event) {
		this.order.orderAt = $event;
		if (!$event) {
			this.order.asap = true;
		} else {
			this.order.asap = false;
		}
	}
	async backOrDismiss() {
		if (this.isOverviewPage) {
			await this.editPersonalData();
		} else {
			await this.dismiss();
		}
	}
	async loadSlots() {
		this.slots = [];
		this.order.orderAt = null;
		if (!this.venue) {
			this.snackbarCtrl.open(this.translate.instant('errors.venue'), null, {
				duration: 2000
			});
			return;
		}
		if (this.loading) {
			return;
		}
		this.loading = true;
		try {
			this.slots = (await getSlotsByOrder(this.venue, this.order, 0, false, 20)).map(slot => moment(slot.time));
			if (this.slots.length === 0) {
				this.loading = false;
				this.snackbarCtrl.open(this.translate.instant('checkout_modal.no_slots'), null, {
					duration: 2000
				});
				return;
			}
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('checkout_modal.time_error'), null, {
				duration: 2000
			});
			console.error(e);
		}
		this.loading = false;
	}
	priceOfOption(articleGroup: ArticleGroup, articleOption: ArticleOption): number {
		const price = getPrice(articleOption.article, OrderType.PREORDER, this.order.preorder.type);
		if (OrderUtils.isBogoOrFreeArticlePromo(this.order) && articleGroup.isPromo) {
			return 0;
		}
		return price * articleOption.quantity;
	}
	createOrderForm() {
		const formControlNames: any = {};
		formControlNames[this.phone] = [Validators.required, this._customPhoneValidatorForLibrary];

		formControlNames[this.fullName] = ['', [Validators.required, Validators.pattern(/\w+\s\w+/)]];
		formControlNames[this.email] = [
			'',
			[
				Validators.required,
				Validators.pattern(
					"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
				)
			]
		];
		formControlNames[this.phone] = ['', [Validators.required, this._customPhoneValidatorForLibrary]];
		formControlNames[this.orderAt] = [''];
		// if (this.order.preorder.type === PreorderType.INSIDE) {
		// 	formControlNames[this.orderAt] = [''];
		// } else {
		// 	formControlNames[this.orderAt] = ['', [Validators.required]];
		// }
		if (this.order?.preorder?.type === PreorderType.DELIVERY) {
			formControlNames[this.street] = ['', [Validators.required]];
			formControlNames[this.houseNumber] = ['', [Validators.required]];
			formControlNames[this.postcode] = ['', [Validators.required]];
			formControlNames[this.city] = ['', [Validators.required]];
		}
		if (this.customer.isAnonymous) {
			formControlNames[this.createAccount] = [false];
		}
		this.orderForm = this.fb.group(formControlNames);
		this.reloadAddress();

		this.orderForm.get(this.createAccount)?.valueChanges?.subscribe(createAccount => {
			if (createAccount) {
				this.orderForm.addControl(
					this.password,
					this.fb.control('', [
						Validators.required,
						Validators.minLength(8),
						Validators.pattern(/\d+/),
						Validators.pattern(/[A-Z]+/)
					])
				);
				this.orderForm.addControl(this.rePassword, this.fb.control('', [Validators.required, this._isPasswordMatch()]));
			}
			if (!createAccount) {
				this.orderForm.removeControl(this.password);
				this.orderForm.removeControl(this.rePassword);
			}
		});
	}
	private _isPasswordMatch(): ValidatorFn {
		return () => {
			const pass = this.orderForm?.get('password')?.value;
			const confirmPass = this.orderForm?.get('rePassword')?.value;
			return pass === confirmPass ? null : {notSame: true};
		};
	}
	private _customPhoneValidatorForLibrary(control: AbstractControl) {
		const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
		try {
			const phoneNumber = phoneUtil.parse(control?.value?.internationalNumber);
			if (phoneUtil.isValidNumber(phoneNumber) && phoneUtil.isPossibleNumber(phoneNumber)) {
				return null;
			} else {
				return {invalidPhone: true};
			}
		} catch (e) {
			return {invalidCountryCode: true};
		}
	}
	getFormControlValue(controlName?: string) {
		if (controlName) {
			return this.orderForm?.get(controlName)?.value;
		}
		return '';
	}
	isValid(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm.get(controlName)?.hasError('required') && this.orderForm.get(controlName)?.touched;
		}
		return this.orderForm?.invalid;
	}

	isValidByPattern(controlName?: string): boolean {
		if (controlName) {
			return this.orderForm.get(controlName)?.errors && !this.orderForm.get(controlName)?.hasError('required');
		}
		return this.orderForm.invalid;
	}

	getErrorsForm(controlName) {
		if (controlName) {
			return this.orderForm.get(controlName).errors;
		}

		return null;
	}

	async backClick() {
		await this.navigationService.menu();
	}
	async signIn() {
		this.modalCtrl.dismiss({changeRoute: true});
	}
	changeTable(table: Table) {
		if (table) {
			this.order.tableNumber = table.number;
			this.order.table = table._id;
			this.repository.order.emit(this.order);
		}
	}

	totalPrice() {
		const orderCopy = JSON.parse(JSON.stringify(this.order));
		const orderCopyWithSub = this.repository.changeOrderWithSubscriptions(
			orderCopy,
			(this.repository?._customerAuth?.subscription ?? []).map(it => it.subscription)
		);
		return numberToCurrency(
			OrderUtils.orderTotalPrice(
				orderCopyWithSub,
				true,
				true,
				(this.order.subscriptions ?? []).concat(
					this.repository.mapUserSubscriptions(this.repository._customerAuth.subscription)
				)
			),
			this.order.currency
		);
	}
	showArticlesWhichHaveDiscount(order: Order) {
		const orderArticles = JSON.parse(JSON.stringify(order.orderedArticles)) as ArticleGroup[];
		const groupByToMap = <T, Q>(array: T[], predicate: (value: T, index: number, array: T[]) => Q) =>
			array.reduce((map, value, index, array) => {
				const key = predicate(value, index, array);
				map.get(key)?.push(value) ?? map.set(key, [value]);
				return map;
			}, new Map<Q, T[]>());
		// take every article how many times how many quantity i have
		const mappedByQuantity = orderArticles.reduce((acc, articleGroup) => {
			acc.push(...Array(articleGroup.quantity).fill({...articleGroup, quantity: 1}));
			return acc;
		}, [] as ArticleGroup[]);
		// GROUP articles with by sub ID
		const groupArray = groupByToMap(mappedByQuantity, v => v.subscription);
		const arrayOfDiscountArticles = [] as ArticleGroup[];
		this.userSubscription.forEach(it => {
			if (groupArray.has(it._id)) {
				const valueOfGroup = groupArray.get(it._id);
				const maxQunatityOfArticles = it.maxArticlesPerOrder;
				//check if i need to add items
				if (!it.maxPricePerOrder && maxQunatityOfArticles > 0) {
					arrayOfDiscountArticles.push(...valueOfGroup.splice(0, maxQunatityOfArticles));
					return;
				}
				if (it.maxPricePerOrder > 0 && maxQunatityOfArticles > 0) {
					let price = 0;
					let quantity = 0;
					valueOfGroup.forEach(articleGroup => {
						if (
							OrderUtils.totalPrice(articleGroup, this.order.type, this.order.preorder.type) + price <
								it.maxPricePerOrder &&
							quantity < it.maxArticlesPerOrder
						) {
							arrayOfDiscountArticles.push(articleGroup);
							price = price + OrderUtils.totalPrice(articleGroup, this.order.type, this.order.preorder.type);
							++quantity;
						}
					});
				}
			}
		});
		const finalArray = [] as ArticleGroup[];
		arrayOfDiscountArticles.forEach(it => {
			const foundArticleIndex = finalArray.findIndex(art => art.article._id === it.article._id);
			if (foundArticleIndex < 0) {
				finalArray.push(it);
			} else {
				finalArray[foundArticleIndex].quantity = ++finalArray[foundArticleIndex].quantity;
			}
		});

		return finalArray;
	}
	fullPrice(isTotalPriceWithSub: boolean = false, isTotalPriceWithPromocode: boolean = false) {
		let totalPrice = this.orderUtils.articleGroupsTotalPrice(
			this.order.orderedArticles,
			this.order.type,
			this.order.preorder.type
		);
		if (isTotalPriceWithSub) {
			const orderCopy = JSON.parse(JSON.stringify(this.order));
			const orderCopyWithSub = this.repository.changeOrderWithSubscriptions(
				orderCopy,
				(this.repository?._customerAuth?.subscription ?? []).map(it => it.subscription)
			);
			totalPrice = OrderUtils.orderTotalPrice(
				orderCopyWithSub,
				true,
				false,
				this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription)
			);
		}
		if (isTotalPriceWithPromocode) {
			const orderCopy = JSON.parse(JSON.stringify(this.order));
			const orderCopyWithSub = this.repository.changeOrderWithSubscriptions(
				orderCopy,
				(this.repository?._customerAuth?.subscription ?? []).map(it => it.subscription)
			);
			totalPrice = OrderUtils.orderTotalPrice(
				orderCopyWithSub,
				true,
				true,
				this.repository.mapUserSubscriptions(this.repository?._customerAuth?.subscription)
			);
		}
		return totalPrice;
	}
	calculateDiscount(discountForSubscription: boolean = false, discountForPromocode: boolean = false) {
		let discount = 0;
		if (discountForSubscription) {
			discount = this.orderUtils.articleGroupsTotalPrice(
				this.showArticlesWhichHaveDiscount(this.order) ?? [],
				this.order.type,
				this.order.preorder.type
			);
		}
		if (discountForPromocode) {
			discount =
				this.orderUtils.orderTotalPrice(this.order, false, true) -
				this.orderUtils.orderTotalPriceWithoutDiscounts(this.order);
		}
		return discount;
	}
}
